import { useMemo } from 'react';
import { AText, Box } from '@alf/uikit';
import { useGeneralRoutes } from '@namespace/cms';
import { LocalizedLink, useI18n, useLocation } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';
import { useUserSegmentsIncludes } from '@namespace/segments';
import { DEFAULT_ACTIVE_TAG, PROMO_TYPES } from '../../../../constants';

import styles from './index.module.css';

export const Categories = ({
  enabledPromoTabs = [],
  normalizedPromoTabs = {},
  activeCategory = ''
}) => {
  const { t } = useI18n();
  const { promotions } = useGeneralRoutes();
  const { pathname } = useLocation();
  const filteredSegments = useUserSegmentsIncludes();

  const preparedCategories = useMemo(
    () =>
      enabledPromoTabs
        ?.map((category) => {
          const tagPath =
            Object.values(normalizedPromoTabs[category].categories)[0]
              ?.categoryName || DEFAULT_ACTIVE_TAG;

          const isWidget = category === PROMO_TYPES.widget;

          if (isWidget) {
            const { pageURL, logoURL, titleTranslationKey, userSegments } =
              normalizedPromoTabs[PROMO_TYPES.widget] || {};
            const isWidgetInSegments = filteredSegments(userSegments);

            if (!isWidgetInSegments) {
              return null;
            }

            return {
              link: `${pathname}${pageURL}`,
              category,
              icon: logoURL,
              title: t(titleTranslationKey)
            };
          }

          return {
            link: `${promotions}/${category}/${tagPath}`,
            category
          };
        })
        .filter((tab) => !!tab),
    [enabledPromoTabs, normalizedPromoTabs, promotions]
  );

  return (
    <Box className={styles.categoriesWrapper}>
      {preparedCategories?.map(({ link, category, icon, title }) => {
        const isActive = category === activeCategory;

        return (
          <LocalizedLink
            to={link}
            className={styles.filtersContainerItem}
            data-role={`promotions-category-${category}`}
            key={category}
          >
            <Box align="center">
              <Icon
                className={styles.filterItemIcon}
                size="s"
                name={icon || `icons/nav_menu/${category}`}
                color={`btn_quaternary_color_${isActive ? '2' : '3'}`}
              />
              <AText
                breed="BU"
                size="m"
                color={`btn_quaternary_color_${isActive ? '2' : '3'}`}
              >
                {title || t(`web.${category}.lobby.title`)}
              </AText>
            </Box>
          </LocalizedLink>
        );
      })}
    </Box>
  );
};
